import { render } from "./GpNrConnectForm.vue?vue&type=template&id=76a72796&ts=true"
import script from "./GpNrConnectForm.vue?vue&type=script&lang=ts"
export * from "./GpNrConnectForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__